import { useEffect, useState } from "react"

const useAdmin = email => {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isAdminLoading, setIsAdminLoding] = useState(true)

    useEffect(() => {
        if (email) {
            fetch(`https://doctor-portal-server-nu.vercel.app/users/admin/${email}`)
                .then(res => res.json())
                .then(data => {
                    setIsAdmin(data.isAdmin);
                    setIsAdminLoding(false)
                });
        }
    }, [email]);

    return [isAdmin, isAdminLoading];

}
export default useAdmin;